import { isApiError, type ApiError } from '@brightlocal/api-client';

/**
 * An ApiError from the token-refresh endpoint that conclusively ended the
 * session, tagged so consumers can distinguish it from ordinary 401/403s on
 * other endpoints (e.g. an entitlement 403 from auth/me must NOT log the
 * user out). The original ApiError shape is preserved, so existing status
 * checks and the central error-reporting handler keep working.
 */
export type SessionExpiredApiError = ApiError & {
  /** Provenance marker set only by `tokenRefreshService` when it expires the session. */
  isSessionExpired: true;
};

/** Tags a refresh-endpoint rejection as the conclusive end of the session. */
export const markSessionExpired = (error: ApiError): SessionExpiredApiError => ({
  ...error,
  isSessionExpired: true
});

/** Narrows an unknown error to a session-ending refresh rejection. */
export const isSessionExpiredError = (error: unknown): error is SessionExpiredApiError =>
  isApiError(error) && 'isSessionExpired' in error && error.isSessionExpired === true;
